import React from "react";
import "../../css/appage.css";

export default function SignOut() {
  return <h1 className="sign-out">NO WAY OUT</h1>;
}
